<section
  class="flex font-open-sans min-h-0 flex-1 flex-col overflow-hidden rounded-3xl border border-border-solid bg-[color-mix(in_srgb,var(--card)_70%,transparent)] shadow-[0_4px_16px_rgba(0,0,0,0.08)] backdrop-blur-[8px] max-sm:rounded-2xl max-lg:max-h-[50vh]">
  <header class="flex items-center gap-3 border-b border-border-solid-50 px-5 py-5 max-sm:px-4 max-sm:py-3">
    <h2 class="header-lg text-foreground max-sm:text-base">{{ 'ACCESS.CHECKIN.LIVE_PICKUP.COMPLETED_LIST_TITLE' |
      translate }}</h2>
  </header>

  <div class="custom-scrollbar-thin flex min-h-0 flex-1 flex-col overflow-y-auto px-5 py-2 max-sm:px-3 min-h-[342px]">
    @if (isLoading()) {
    @for (row of skeletonRows; track row) {
    <article
      class="flex items-center justify-between gap-4 border-b border-dashed border-border-solid py-3 last:border-0">
      <div class="flex min-w-0 items-center gap-3">
        <lib-skeleton-loader [count]="1"
          [theme]="{ width: '36px', height: '36px', borderRadius: '9999px', margin: '0' }"></lib-skeleton-loader>
        <div class="flex min-w-0 flex-col gap-1.5">
          <lib-skeleton-loader [count]="1"
            [theme]="{ width: '140px', height: '14px', borderRadius: '6px', margin: '0' }"></lib-skeleton-loader>
          <lib-skeleton-loader [count]="1"
            [theme]="{ width: '96px', height: '12px', borderRadius: '6px', margin: '0' }"></lib-skeleton-loader>
        </div>
      </div>

      <div class="flex shrink-0 flex-col items-end gap-1.5">
        <lib-skeleton-loader [count]="1"
          [theme]="{ width: '60px', height: '12px', borderRadius: '6px', margin: '0' }"></lib-skeleton-loader>
        <lib-skeleton-loader [count]="1"
          [theme]="{ width: '48px', height: '14px', borderRadius: '6px', margin: '0' }"></lib-skeleton-loader>
      </div>
    </article>
    }
    } @else if (hasError()) {
    <lib-error-state (retry)="retry.emit()" />
    } @else if (students().length === 0) {
    <div class="m-3 flex min-h-0 flex-1 flex-col items-center justify-center px-8 py-14 text-center">
      <h3 class="mb-2 max-w-[420px] text-[20px] font-semibold leading-tight tracking-tight text-foreground">
        {{ 'ACCESS.CHECKIN.LIVE_PICKUP.COMPLETED_EMPTY_TITLE' | translate }}
      </h3>
      <p class="content-regular max-w-[380px] text-muted-foreground">
        {{ 'ACCESS.CHECKIN.LIVE_PICKUP.COMPLETED_EMPTY_DESCRIPTION' | personNounLabel }}
      </p>
      <lib-badge class="mt-5" type="outline">
        <div class="flex items-center gap-[6px]">
          <i class="fi fi-rr-time-past text-[12px] leading-[0] text-foreground-75"></i>
          <p>{{ 'ACCESS.CHECKIN.LIVE_PICKUP.WAITING_FIRST_PICKUP' | translate }}</p>
        </div>
      </lib-badge>
    </div>
    } @else {
    @for (student of students(); track student.id) {
    <article
      class="flex items-center justify-between gap-4 border-b border-dashed border-border-solid py-3 last:border-0">
      <div class="flex min-w-0 items-center gap-3">
        <lib-avatar size="sm" [personId]="student.studentPersonId" />
        <div class="flex min-w-0 flex-col">
          <span class="content-semibold truncate text-foreground">
            {{ student.name }}
          </span>
          <!-- TODO(live-pickup): reativar quando o backend enviar StudentClassDisplay.
          <span class="content-sm-regular truncate text-foreground-75">
            {{ student.className }}
          </span>
          -->
        </div>
      </div>

      <div class="flex shrink-0 flex-col items-end gap-0.5">
        <span class="content-sm-regular flex items-center gap-1 text-foreground-75">
          <i class="fi fi-rr-marker text-[12px]"></i>
          {{ student.gate }}
        </span>
        <span class="content-semibold tabular-nums text-foreground">
          {{ student.completedOnUtc | intlDateTime: { hour: '2-digit', minute: '2-digit' } }}
        </span>
      </div>
    </article>
    }
    }
  </div>
</section>